import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone',
})
export class PhonePipe implements PipeTransform {
  transform(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^\+?(\d{0,3}?)(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      if (match[1]) {
        return (
          '+' + match[1] + ' (' + match[2] + ') ' + match[3] + '-' + match[4]
        );
      } else {
        return '(' + match[2] + ') ' + match[3] + '-' + match[4];
      }
    }
    return phoneNumberString;
  }
}
